<template>
  <!-- <transition name="modal-fade"> -->
  <div
    class="mb-audio-in-game"
    :style="{
      position: itemData.position || 'absolute',
      top: itemData.pos.y + itemData.unit || '%',
      left: itemData.pos.x + itemData.unit || '%',
      background: itemData.background || 'transparent',
      width: itemData.width || '10vh',
      height: itemData.height || '10vh',
    }"
  >
    <img
      draggable="false"
      v-if="wrapState"
      :src="wrap"
      @click="uncoverWhatIsHidden()"
      :style="wrapStyle"
      class="wrap-image"
    />
    <svg
      v-if="globalIcons.on == ''"
      class="play-stop svg-button-on"
      @click="playerLetMeKnowWhatShouldIDo()"
      viewBox="0 0 24 24"
    >
      <!-- <transition name="click-fade"> -->
      <path
        v-if="!audioStatus"
        d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"
      />
      <!-- </transition> -->
      <!-- <transition name="click-fade"> -->
      <path
        v-if="audioStatus"
        d="M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z"
      />
      <!-- </transition> -->
    </svg>
    <div
      v-if="globalIcons.on != ''"
      @click="playerLetMeKnowWhatShouldIDo()"
      class="icon-png"
      @mouseenter="iconHover = true"
      @mouseleave="iconHover = false"
    >
      <transition name="click-fade">
        <img draggable="false" :src="globalIcons.on" />
      </transition>
      <transition name="click-fade">
        <img draggable="false" v-if="audioStatus || iconHover" :src="globalIcons.off" />
      </transition>
    </div>
  </div>
  <!-- </transition> -->
</template>
<script type="text/javascript">
import { Howler } from 'howler';
export default {
  name: 'mb-audio-in-game',
  props: {
    itemData: {
      type: Object,
      default: () => {
        return {};
      },
    },
    maskData: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data() {
    return {
      wrap: null,
      wrapStyle: null,
      iconHover: false,
      volumeValue: 1,
      audio: null,
      audioStatus: false,
      audioClick: null,
      globalIcons: {
        on: '',
        off: '',
      },
    };
  },
  watch: {
    gameCheckSwitch(newValue) {
      if (newValue) {
        this.stopPlay();
      }
    },
  },
  computed: {
    gameCheckSwitch() {
      return this.$store.getters.gameCheckSwitch;
    },
    maskId() {
      return this.itemData.id;
    },
    wrapState() {
      let state = false,
        elem = this.maskData.find((el) => el.id == this.maskId);
      if (elem !== undefined) state = elem.isWrapped;
      return state;
    },
  },
  methods: {
    giveMeImagePlease(path) {
      return require(`__staticDir/${this.$store.getters.multibookType}/${path}`);
    },
    playerLetMeKnowWhatShouldIDo() {
      if (!this.audioStatus) {
        Howler.stop();
        this.audio.play();
        this.audioStatus = this.changeState(this.audioStatus);
      } else {
        this.stopPlay();
        this.audioStatus = this.changeState(this.audioStatus);
      }
    },
    changeState(value) {
      return !value;
    },
    stopPlay() {
      this.audio.stop();
    },
    uncoverWhatIsHidden() {
      if (this.itemData.maskConfig && this.itemData.maskConfig.click) {
        this.audioClick.play();
      }
      let newMaskData = this.maskData;
      newMaskData.find((el) => el.id == this.maskId).isWrapped = false;
      this.$emit('change-item-mask', { item: newMaskData });
    },
    setAudioConfig() {
      if (this.itemData.maskConfig && this.itemData.maskConfig.src) {
        this.wrap = this.giveMeImagePlease(this.itemData.maskConfig.src);
        this.wrapStyle = this.itemData.maskConfig?.cssStyle;
      }
      if (this.itemData.maskConfig && this.itemData.maskConfig.click) {
        this.audioClick = new Howl({
          src: this.giveMeImagePlease(this.itemData.maskConfig.click.src),
          autoplay: false,
          loop: false,
          volume: 0.5,
        });
      }
      if (this.itemData.iconConfig) {
        if (!this.itemData.iconConfig.src) {
          try {
            this.globalIcons.on = require('__mainSrcDir/config/audioIconConfig/index.js').AUDIO_ON;
            this.globalIcons.off = require('__mainSrcDir/config/audioIconConfig/index.js').AUDIO_OFF;
          } catch {
            console.log(
              '%caudioIconConfig - error',
              'font-weight: bold; background: red; color: white; padding: 0px 10px'
            );
          }
        } else {
          this.globalIcons.on = this.giveMeImagePlease(this.itemData.iconConfig.src.iconOn);
          this.globalIcons.off = this.giveMeImagePlease(this.itemData.iconConfig.src.iconOff);
        }
      }
      this.audio = new Howl({
        src: this.giveMeImagePlease(this.itemData.src),
        autoplay: this.itemData.audioConfig.autoplay || false,
        loop: this.itemData.audioConfig.loop || false,
        volume: this.itemData.audioConfig.volume || 1,
        onend: () => {
          this.audioStatus = false;
          // console.log('end');
        },
        onpause: () => {
          this.audioStatus = false;
          // console.log('end');
        },
        onstop: () => {
          this.audioStatus = false;
          // console.log('end');
        },
        onplay: () => {
          this.audioStatus = true;
          // console.log('sztart');
        },
      });
    },
  },
  beforeMount() {
    this.setAudioConfig();
  },
  destroyed() {
    this.stopPlay();
  },
};
</script>

<style lang="sass" scoped>
.mb-audio-in-game
  display: inline-block
  z-index: 1
  background: white
  line-height: 0
  //box-shadow: 0vh 0vh 2vh 1vh rgba(0,0,0,0.34)
  .wrap-image
    position: absolute
    z-index: 1
  .play-stop, .stop-audio
    width: 100%
    height: 100%
    transform-origin: center
    path
    transform-origin: center
  svg
    transition: 0.5s
    path
    transition: 0.5s
  // .svg-button-on
    // transition: 0.5s
    // cursor: pointer
    // transform: scale(.8, .8)
    // &:hover
    //   transform: scale(1, 1)
  .icon-png
    cursor: pointer
    width: 100%
    height: 100%
    transition: 0.5s
    transform-origin: center
    // transform: scale(.8, .8)
    &:hover
      // transform: scale(1, 1)
    img
      transition: 0.5s
      position: absolute
      width: 100%
      height: 100%
      left: 0
      top: 0
@keyframes textMove
  48%
    left: -60vw
    opacity: 1
  49%
    left: -60vw
    opacity: 0
  50%
    left: 60vw
    opacity: 0
  51%
    opacity: 1
    left: 60vw

.modal-fade-leave-active, .modal-fade-enter-active
  transition: all .5s linear
.modal-fade-leave-to, .modal-fade-enter
  transform: translateY(-20vh)
  opacity: 0
.click-fade-leave-active, .click-fade-enter-active
  transition: all .3s linear
.click-fade-leave-to, .click-fade-enter
  opacity: 0
</style>
<style lang="scss">
@import '~@/assets/sass/iconColor';
@import '~@/assets/sass/titleStyle';

.svg-button-on {
  color: $secondIconColor;
  background-color: $firstIconColor;
  transition: 0.2s;
  border-radius: 50%;
  &:hover {
    // background-color: rgb(40, 196, 36);
    color: $firstIconColor;
    background-color: $secondIconColor;
    // .audio-icon {
    //     color: $secondIconColor;
    //     background-color: $firstIconColor;
    // }
    path {
      fill: #00a8ec;
    }
  }
  path {
    width: 100%;
    height: 100%;
    fill: white;
    transition: 0.2s;
  }
}
</style>
